import { useEffect, useState } from "react";

import { useRoutes, type RouteObject } from "react-router-dom";
import { adminRoutes, routes } from "router";
import { ConfigProvider, Spin } from "antd";
import { useRouter } from "hooks/useRouter";
import { userStore } from "store/userStore";
import { observer } from "mobx-react";
import { settings } from "settings";
import { permissionStore } from "store/permissionStore";
import { viVNLocale } from "utils/locale";
import { initUUID } from "utils/device";

const App = observer(() => {
  const element = useRoutes(routes as RouteObject[]);
  const [isLoaded, setIsLoaded] = useState(false);
  useRouter(isLoaded);

  useEffect(() => {
    initUUID();
    handleInit();
  }, []);

  const handleInit = async () => {
    try {
      if (userStore.token) {
        await userStore.getProfile();
        permissionStore.accessRoutes = [...adminRoutes];
        if (settings.checkPermission && userStore.info.role) {
          await permissionStore.fetchPermissions(userStore.info.role.id);
          permissionStore.setAccessRoutes();
        }
      }
    } catch (error) {
      userStore.logout();
    } finally {
      setIsLoaded(true);
    }
  };

  return (
    <ConfigProvider
      locale={viVNLocale}
      theme={{
        token: {
          colorPrimary: "var(--color-primary)",
          controlOutline: "transparent",
          controlOutlineWidth: 0,
        },
        components: {
          Select: {
            activeBorderColor: "var(--color-primary)",
            activeOutlineColor: "transparent",
          },
          Input: {
            activeBorderColor: "var(--color-primary)",
            hoverBorderColor: "var(--color-primary)",
          },
          Checkbox: {
            colorPrimary: "var(--color-primary)",
            colorPrimaryHover: "var(--color-primary)",
          },
        },
      }}
    >
      {isLoaded ? (
        <div className="App app-ant-design-system">{element}</div>
      ) : (
        <div
          className="loading"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
          }}
        >
          <Spin size="large" />
        </div>
      )}
    </ConfigProvider>
  );
});

export default App;
